// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Sicurezza e gestione utenti ======
// Cache locale degli utenti del portale (caricata da Supabase a ogni render)
let _users = [];

async function renderSicurezza() {
  if (!isAdmin()) return;
  // Carica anche la lista backup e il cestino quando l'admin entra in Sicurezza
  if (typeof renderBackups === 'function') renderBackups();
  if (typeof renderTrash === 'function') renderTrash();
  try {
    _users = await api.listUsers();
  } catch (e) {
    console.error(e);
    toast('Errore caricamento utenti: ' + (e.message || e));
    return;
  }
  const me = getCurrentUser();
  const myProfileId = me ? me.portaleId : null;

  const tbody = $('#tbodyUsers');
  tbody.innerHTML =
    _users
      .map(
        (u) => `
    <tr data-uid="${escapeHtml(u.id)}">
      <td data-label="Nome"><strong>${escapeHtml(u.name)}</strong></td>
      <td data-label="Email">${escapeHtml(u.email)}</td>
      <td data-label="Ruolo"><span class="role-badge ${u.role === 'admin' ? 'admin' : 'utente'}">${roleLabel(u.role)}</span></td>
      <td data-label="Risorsa">${escapeHtml(u.resourceName || '—')}</td>
      <td data-label="Accesso">${u.linked ? '<span class="status status-si">Login attivo</span>' : '<span class="status status-darichiedere">Mai loggato</span>'}</td>
      <td data-label="Stato"><span class="user-state ${u.active ? 'active' : 'inactive'}">${u.active ? 'Attivo' : 'Disattivato'}</span></td>
      <td class="user-actions">
        <button class="btn btn-sm" data-edit="${escapeHtml(u.id)}">Modifica</button>
        ${!u.linked ? `<button class="btn btn-sm btn-primary" data-invite="${escapeHtml(u.email)}" title="Invia magic-link via email"><svg class="btn-svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>Invita</button>` : ''}
        <button class="btn btn-sm" data-toggle="${escapeHtml(u.id)}">${u.active ? 'Disattiva' : 'Attiva'}</button>
        ${u.id !== myProfileId ? `<button class="btn btn-sm btn-danger" data-del-user="${escapeHtml(u.id)}">Elimina</button>` : ''}
      </td>
    </tr>`
      )
      .join('') ||
    '<tr><td colspan="7" style="text-align:center;padding:30px;color:var(--text-muted)">Nessun utente censito.</td></tr>';
  tbody
    .querySelectorAll('[data-edit]')
    .forEach((b) => b.addEventListener('click', () => openUserModal(b.dataset.edit)));
  tbody
    .querySelectorAll('[data-toggle]')
    .forEach((b) => b.addEventListener('click', () => toggleUser(b.dataset.toggle)));
  tbody
    .querySelectorAll('[data-del-user]')
    .forEach((b) => b.addEventListener('click', () => deleteUser(b.dataset.delUser)));
  tbody
    .querySelectorAll('[data-invite]')
    .forEach((b) => b.addEventListener('click', () => inviteUser(b.dataset.invite)));
}

async function inviteUser(email) {
  if (!isAdmin()) return;
  try {
    const { data, error } = await sb.functions.invoke('invite-user', { body: { email } });
    if (error) throw error;
    if (data && data.ok) {
      logAudit({
        action: 'system',
        entity: 'Utente',
        target: email,
        details: `Invito inviato a ${data.sent_to}${data.dev ? ' (DEV)' : ''}`
      });
      toast(`Invito inviato a ${data.sent_to}`);
    } else {
      toast('Errore invito: ' + (data?.error || 'risposta non valida'));
    }
  } catch (e) {
    console.error(e);
    toast('Edge function "invite-user" non disponibile. Deploya prima la function.');
  }
}

function openUserModal(id) {
  if (!isAdmin()) return;
  globalThis.editingUserId = id || null;
  const u = id ? _users.find((x) => x.id === id) : null;
  $('#modalUserTitle').textContent = u ? 'Modifica utente' : 'Nuovo utente';
  const f = $('#formUser');
  f.reset();
  f.id.value = u?.id || '';
  f.name.value = u?.name || '';
  f.email.value = u?.email || '';
  f.role.value = u?.role || 'utente';
  f.active.checked = u ? !!u.active : true;
  // Campo password e hint nascosti: la password e' gestita da Supabase Auth
  if (f.password) {
    f.password.value = '';
    f.password.closest('.form-field')?.classList.add('hidden');
  }
  f.resourceName.innerHTML =
    '<option value="">— Nessuna —</option>' +
    state.resources
      .map(
        (r) =>
          `<option value="${escapeHtml(r)}" ${u?.resourceName === r ? 'selected' : ''}>${escapeHtml(r)}</option>`
      )
      .join('');
  $('#modalUser').classList.remove('hidden');

  // Snapshot per dirty-check
  const snapshot = JSON.stringify({
    name: f.name.value,
    email: f.email.value,
    role: f.role.value,
    resourceName: f.resourceName.value,
    active: f.active.checked
  });
  if (typeof registerDirtyGuard === 'function') {
    registerDirtyGuard(
      'modal-utente',
      () => {
        const ff = $('#formUser');
        if (!ff || $('#modalUser').classList.contains('hidden')) return false;
        const now = JSON.stringify({
          name: ff.name.value,
          email: ff.email.value,
          role: ff.role.value,
          resourceName: ff.resourceName.value,
          active: ff.active.checked
        });
        return now !== snapshot;
      },
      u ? `Modifica utente "${u.name}"` : 'Nuovo utente'
    );
  }
}

async function toggleUser(id) {
  if (!isAdmin()) return;
  const u = _users.find((x) => x.id === id);
  if (!u) return;
  const me = getCurrentUser();
  if (me && u.id === me.portaleId && u.active) {
    toast('Non puoi disattivare il tuo stesso account');
    return;
  }
  try {
    await api.toggleUserActive(id, !u.active);
    logAudit({
      action: 'update',
      entity: 'Utente',
      target: u.name,
      details: !u.active ? 'Utente attivato' : 'Utente disattivato'
    });
    await renderSicurezza();
    toast(!u.active ? 'Utente attivato' : 'Utente disattivato');
  } catch (e) {
    console.error(e);
    toast('Errore: ' + (e.message || e));
  }
}

async function deleteUser(id) {
  if (!isAdmin()) return;
  const u = _users.find((x) => x.id === id);
  if (!u) return;
  const me = getCurrentUser();
  if (me && u.id === me.portaleId) {
    toast('Non puoi eliminare il tuo account');
    return;
  }
  const isAdminUser = u.role === 'admin';
  const otherAdmins = _users.filter((x) => x.role === 'admin' && x.id !== u.id).length;
  if (isAdminUser && otherAdmins === 0) {
    toast(`Impossibile eliminare "${u.name}": è l'ultimo admin.`);
    return;
  }
  const ok = await confirmAction({
    level: 'warning',
    title: 'Eliminare utente',
    message: `Stai per eliminare l'utente "${u.name}" (${u.email}).`,
    details: [
      `Ruolo attuale: ${isAdminUser ? 'Admin' : 'Utente'}`,
      u.resourceName ? `Risorsa collegata: ${u.resourceName}` : 'Nessuna risorsa collegata',
      u.linked
        ? "Perderà l'accesso al portale (l'account auth resta in Supabase)"
        : 'Non aveva ancora effettuato il primo login',
      'Lo storico delle sue azioni resta visibile per audit'
    ],
    warning: isAdminUser ? 'Stai eliminando un account amministratore.' : '',
    confirmText: 'Elimina utente'
  });
  if (!ok) return;
  try {
    await api.deleteUser(id);
    logAudit({ action: 'delete', entity: 'Utente', target: u.name, details: 'Utente eliminato' });
    notifyCritical?.('utente.deleted', { name: u.name, email: u.email, role: u.role });
    await renderSicurezza();
    toast('Utente eliminato');
  } catch (e) {
    console.error(e);
    toast('Errore: ' + (e.message || e));
  }
}

// CSV Parser
function parseCSV(text) {
  const rows = [];
  let cur = '',
    row = [],
    inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (inQuotes) {
      if (ch === '"') {
        if (text[i + 1] === '"') {
          cur += '"';
          i++;
        } else inQuotes = false;
      } else cur += ch;
    } else {
      if (ch === '"') inQuotes = true;
      else if (ch === ',' || ch === ';') {
        row.push(cur);
        cur = '';
      } else if (ch === '\n') {
        row.push(cur);
        rows.push(row);
        row = [];
        cur = '';
      } else if (ch === '\r') {
        /* skip */
      } else cur += ch;
    }
  }
  if (cur.length > 0 || row.length > 0) {
    row.push(cur);
    rows.push(row);
  }
  return rows.filter((r) => r.length && r.some((c) => c && c.trim()));
}

// Event listeners sicurezza
document.getElementById('btnAddUser').addEventListener('click', () => openUserModal(null));

document.getElementById('formUser').addEventListener('submit', async (e) => {
  e.preventDefault();
  if (!isAdmin()) return;
  const f = e.target;
  const id = f.id.value || null;
  const name = f.name.value.trim();
  const email = f.email.value.trim().toLowerCase();
  const role = f.role.value;
  const resourceName = f.resourceName.value;
  const active = f.active.checked;
  if (!name || !email) return;
  if (_users.some((u) => u.email.toLowerCase() === email && u.id !== id)) {
    toast('Email già in uso');
    return;
  }

  const existing = id ? _users.find((u) => u.id === id) : null;
  try {
    await api.upsertUser({ id, name, email, role, resourceName, active });
    if (existing) {
      const changes = [];
      if (existing.name !== name) changes.push({ field: 'Nome', from: existing.name, to: name });
      if (existing.email !== email)
        changes.push({ field: 'Email', from: existing.email, to: email });
      if (existing.role !== role)
        changes.push({ field: 'Ruolo', from: roleLabel(existing.role), to: roleLabel(role) });
      if ((existing.resourceName || '') !== (resourceName || ''))
        changes.push({
          field: 'Risorsa',
          from: existing.resourceName || '—',
          to: resourceName || '—'
        });
      if (existing.active !== active)
        changes.push({ field: 'Attivo', from: String(existing.active), to: String(active) });
      if (changes.length) logAudit({ action: 'update', entity: 'Utente', target: name, changes });
    } else {
      logAudit({
        action: 'create',
        entity: 'Utente',
        target: name,
        details: `Utente creato · Ruolo: ${roleLabel(role)}${resourceName ? ' · Risorsa: ' + resourceName : ''}`
      });
    }
    closeModals();
    await renderSicurezza();
    toast(existing ? 'Utente aggiornato' : 'Utente creato (in attesa di primo login)');
  } catch (err) {
    console.error(err);
    toast('Errore salvataggio utente: ' + (err.message || err));
  }
});

const btnDownloadTemplate = document.getElementById('btnDownloadCsvTemplate');
if (btnDownloadTemplate)
  btnDownloadTemplate.addEventListener('click', () => {
    const csv = [
      'email,name,role,resourceName,active',
      'mario.rossi@agic.it,Mario Rossi,utente,Mario Rossi,true',
      'admin2@agic.it,Admin Secondario,admin,,true'
    ].join('\n');
    downloadFile('utenti-template.csv', csv, 'text/csv');
  });

const fileImportCreds = document.getElementById('fileImportCreds');
if (fileImportCreds)
  fileImportCreds.addEventListener('change', async (e) => {
    if (!isAdmin()) {
      e.target.value = '';
      return;
    }
    const file = e.target.files[0];
    if (!file) return;
    try {
      const text = await file.text();
      const rows = parseCSV(text);
      if (!rows.length) {
        toast('File vuoto');
        e.target.value = '';
        return;
      }
      const header = rows[0].map((h) => h.trim().toLowerCase());
      const idx = {
        email: header.indexOf('email'),
        name: header.indexOf('name'),
        role: header.indexOf('role'),
        resourceName: header.indexOf('resourcename'),
        active: header.indexOf('active')
      };
      if (idx.email < 0 || idx.name < 0) {
        toast('Intestazioni mancanti: email e name sono obbligatori');
        e.target.value = '';
        return;
      }
      await renderSicurezza(); // refresh cache _users
      let created = 0,
        updated = 0,
        skipped = 0;
      for (let i = 1; i < rows.length; i++) {
        const r = rows[i];
        const email = (r[idx.email] || '').trim().toLowerCase();
        const name = (r[idx.name] || '').trim();
        let role = idx.role >= 0 ? (r[idx.role] || '').trim().toLowerCase() : 'utente';
        if (role === 'risorsa') role = 'utente';
        if (role !== 'admin' && role !== 'utente') role = 'utente';
        const resourceName = idx.resourceName >= 0 ? (r[idx.resourceName] || '').trim() : '';
        const activeRaw = idx.active >= 0 ? (r[idx.active] || '').trim().toLowerCase() : 'true';
        const active = !['false', '0', 'no', 'off', 'disattivo', 'inattivo'].includes(activeRaw);
        if (!email || !name) {
          skipped++;
          continue;
        }
        const existing = _users.find((u) => (u.email || '').toLowerCase() === email);
        try {
          await api.upsertUser({
            id: existing?.id || null,
            email,
            name,
            role,
            resourceName,
            active
          });
          if (existing) {
            const changes = [];
            if (existing.name !== name)
              changes.push({ field: 'Nome', from: existing.name, to: name });
            if (existing.role !== role)
              changes.push({ field: 'Ruolo', from: roleLabel(existing.role), to: roleLabel(role) });
            if ((existing.resourceName || '') !== resourceName)
              changes.push({
                field: 'Risorsa',
                from: existing.resourceName || '—',
                to: resourceName || '—'
              });
            if (existing.active !== active)
              changes.push({ field: 'Attivo', from: String(existing.active), to: String(active) });
            if (changes.length)
              logAudit({ action: 'update', entity: 'Utente', target: name, changes });
            updated++;
          } else {
            logAudit({
              action: 'create',
              entity: 'Utente',
              target: name,
              details: `Importato da CSV · Ruolo: ${roleLabel(role)}`
            });
            created++;
          }
        } catch (err) {
          console.error('Riga CSV ignorata:', r, err);
          skipped++;
        }
      }
      await renderSicurezza();
      toast(`Import: ${created} creati, ${updated} aggiornati, ${skipped} ignorati`);
    } catch (err) {
      alert('Errore import CSV: ' + err.message);
    }
    e.target.value = '';
  });

// Export / Import dati clienti — i bottoni vivono nella vista "clienti" (lazy):
// wiring mount-safe e idempotente (bindOnce), rieseguito dopo l'iniezione.
function wireClientiExportButtons() {
  bindOnce(document.getElementById('btnExport'), 'click', () =>
    downloadFile('clienti-mase.json', JSON.stringify(state, null, 2), 'application/json')
  );
  bindOnce(document.getElementById('btnExportCSV'), 'click', () => {
    const headers = [
      'Cliente',
      'CPL',
      'PM1',
      'PM2',
      'Tecnici',
      'Service Line ref',
      'Perimetri',
      'Tenant ID',
      'Ruolo',
      'Assegnazione perenne',
      'Directory',
      'PIM',
      'Note',
      'Contratto numero',
      'Contratto tipo',
      'Contratto inizio',
      'Contratto fine',
      'Referenti',
      'Scadenze aperte',
      ...state.resources
    ];
    const rows = [headers];
    state.clients.forEach((c) => {
      const ref = (c.referenti || [])
        .map((r) => r.nome)
        .filter(Boolean)
        .join(' | ');
      const scad = (c.scadenze || [])
        .filter((s) => !s.completata)
        .map((s) => `${s.titolo} (${s.data})`)
        .join(' | ');
      const row = [
        c.nome,
        c.cpl,
        c.pm1,
        c.pm2,
        (c.tecnici || []).join(' | '),
        c.serviceLineRef,
        (c.perimetri || []).join(' | '),
        c.tenantId,
        c.ruolo,
        c.assegnazionePerenne,
        c.directory,
        c.pim,
        c.note,
        c.contratto?.numero || '',
        c.contratto?.tipo || '',
        c.contratto?.inizio || '',
        c.contratto?.fine || '',
        ref,
        scad
      ];
      state.resources.forEach((r) => row.push(c.accessi?.[r] || ''));
      rows.push(row);
    });
    const csv = rows
      .map((r) =>
        r
          .map((x) => {
            const s = String(x || '')
              .replace(/"/g, '""')
              .replace(/\n/g, ' ');
            return /[",;]/.test(s) ? `"${s}"` : s;
          })
          .join(';')
      )
      .join('\n');
    downloadFile('clienti-mase.csv', '﻿' + csv, 'text/csv');
  });
}
document.addEventListener('DOMContentLoaded', wireClientiExportButtons);
globalThis.bus?.on?.('view:lazy-loaded', (p) => {
  if (p && p.viewId === 'clienti') wireClientiExportButtons();
});

document.getElementById('fileImport')?.addEventListener('change', (e) => {
  if (!isAdmin()) {
    e.target.value = '';
    return;
  }
  e.target.value = '';
  toast(
    'Import JSON disabilitato: i dati vivono ora su Supabase. Usa il SQL Editor per importazioni massive.'
  );
});

// btnReseed e btnWipe sono stati rimossi dall'HTML — i listener restano
// difensivi (?.) nel caso vengano reintrodotti in futuro.
document.getElementById('btnReseed')?.addEventListener('click', async () => {
  if (!isAdmin()) return;
  toast('Il reseed va eseguito dal SQL Editor di Supabase (file seed/seed-portale-mase.sql)');
});

document.getElementById('btnWipe')?.addEventListener('click', async () => {
  if (!isAdmin()) return;
  toast(
    'Cancellazione massiva disabilitata: usa il SQL Editor di Supabase per operazioni destrutive sui dati.'
  );
});

Object.assign(globalThis, {
  renderSicurezza,
  openUserModal,
  toggleUser,
  deleteUser,
  inviteUser,
  parseCSV
});
export {};
